module.exports = __webpack_public_path__ + "static/media/clinica-front.bc281861.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/clinica-front.jpg
// module id = 107
// module chunks = 0